import { Children, isValidElement, type ReactNode } from 'react'

export function getRecursiveChildText(reactNode: ReactNode): string {
    try {
        const element = Children.only(reactNode)

        if (isValidElement(element)) {
            if (typeof element.props.children === 'object') {
                return getRecursiveChildText(element.props.children)
            } else {
                return String(element.props.children)
            }
        } else {
            return String(element)
        }
    } catch (e) {
        return (
            Children.map(reactNode, (node) => {
                if (typeof node === 'string') {
                    return node
                }

                if (typeof node === 'number') {
                    return String(node)
                }

                if (typeof node === 'boolean' || !node) {
                    return ''
                }

                if (typeof node === 'object') {
                    return getRecursiveChildText(node)
                }
            })?.join('') || ''
        )
    }
}
